import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["progressDiv"];
  connect() {
    try {
      var percentValue =
        this.progressDivTarget.getAttribute("attr-percent-value");
      var prePercent = this.progressDivTarget.getAttribute(
        "attr-pre-percent-value"
      );
      this.progressDivTarget.animate(
        [
          { left: `calc(-100% + ${prePercent}%)` },
          { left: `calc(-100% + ${percentValue}%)` },
        ],
        { duration: 300, easing: "ease" }
      );
      this.progressDivTarget.style.left = `calc(-100% + ${percentValue}%)`;
      const anchorTags = this.element.querySelectorAll("a");

      // Do something with each anchor tag
      anchorTags.forEach((anchor) => {
        anchor.addEventListener("click", this.handleAnchorClick.bind(this));
      });
    } catch (err) {}
    this.showContinueButton();
  }

  handleAnchorClick() {
    var percentValue =
      this.progressDivTarget.getAttribute("attr-percent-value");
    var prePercent = this.progressDivTarget.getAttribute(
      "attr-pre-percent-value"
    );
    const previousPosition = `calc(-100% + ${prePercent}%)`;

    this.progressDivTarget.animate(
      [
        { left: `calc(-100% + ${percentValue}%)` },
        { left: previousPosition },
      ],
      { duration: 300, easing: "ease" }
    );
    this.progressDivTarget.style.left = previousPosition;
  }

  showContinueButton() {
    const checkboxes = this.element.querySelectorAll("input[type='checkbox']");
    const submitButton = this.element.querySelector(
      "[data-form-multiple-target='submit']"
    );

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        if (this.isAnyCheckboxChecked(checkboxes)) {
          submitButton.classList.remove("hidden");
        } else {
          submitButton.classList.add("hidden");
        }
      });
    });
  }

  isAnyCheckboxChecked(checkboxes) {
    return Array.from(checkboxes).some((checkbox) => checkbox.checked);
  }
}
